import { render, staticRenderFns } from "./GridEventsCard.vue?vue&type=template&id=0290ed3d"
import script from "./GridEventsCard.vue?vue&type=script&lang=ts"
export * from "./GridEventsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports